var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.16667 0H11.6667C12.311 0 12.8333 0.522334 12.8333 1.16667V9.33333C12.8333 9.97766 12.311 10.5 11.6667 10.5H1.16667C0.522334 10.5 0 9.97766 0 9.33333V1.16667C0 0.522334 0.522334 0 1.16667 0ZM1.16602 3.85994V9.33268H11.666V3.86066L6.41648 6.48543L1.16602 3.85994ZM1.16602 2.55554L6.41651 5.18105L11.666 2.55629V1.16602H1.16602V2.55554Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.bfa3c97f.svg";
export { ForwardRef as ReactComponent };